<template>
    <d-container fluid class="main-content-container px-4">
        <d-row>
            <d-col lg="12" class="mx-auto mt-4">
                <h3 class="page-title">Update payment info</h3>
                <d-card class="card-small edit-user-details mb-4">
                    <d-card-body class="p-0">
                        <d-form class="py-4">
                            <div class="p-4">
                                <d-card>
                                    <d-card-body>
                                        <d-col class="form-group">
                                            <label for="payment">Payment method</label>
                                            <d-form-select required v-model="selectedPaymentMethod">
                                                <option v-for="item in paymentMethods" :value="item.provider_method">{{ item.name }}</option>
                                            </d-form-select>
                                        </d-col>
                                    </d-card-body>
                                </d-card>
                            </div>
                        </d-form>
                    </d-card-body>
                    <d-card-footer class="border-top d-flex justify-content-end">
                        <d-button @click="requestUpdatePaymentInfo" type="button" class="btn ml-3 btn-success">Update</d-button>
                    </d-card-footer>
                </d-card>
            </d-col>
        </d-row>
    </d-container>
</template>

<script>
import { BillingService } from '@/main';

export default {

    data() {
        return {
            paymentMethods: [],
            selectedPaymentMethod: null,
        };
    },
    methods: {
        async getPaymentMethods() {
            this.paymentMethods = await BillingService.getPaymentMethods()
        },

        async requestUpdatePaymentInfo() {
            console.log('f', this.selectedPaymentMethod)
            const urlForUpdatePaymentInfo = await BillingService.requestUpdatePaymentInfo(this.selectedPaymentMethod)

            if (urlForUpdatePaymentInfo) {
                window.location.replace(urlForUpdatePaymentInfo)
            }
        },
    },

    created() {
        this.getPaymentMethods()
    },
};
</script>
